// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fp-a";
export var fulfillmentFormRail = "_fp-9";
export var headerTitleRow = "_fp-c";
export var orderDetailsWrapper = "_fp-7";
export var orderLinkTrigger = "_fp-2";
export var paymentInformationGrid = "_fp-h";
export var paymentSummaryColumn = "_fp-i";
export var shipmentContainer = "_fp-b";
export var shipmentDetailsMainPane = "_fp-8";
export var shipmentNavigationCard = "_fp-5";
export var shipmentNavigationRail = "_fp-3";
export var shipmentNavigationRailHeader = "_fp-4";
export var shipmentSummaryFact = "_fp-e";
export var shipmentSummaryGrid = "_fp-d";
export var shipmentSummaryMetadataRow = "_fp-f";
export var shipmentSummaryTags = "_fp-g";
export var shipmentWorkspace = "_fp-0";
export var shipmentWorkspaceContent = "_fp-6";
export var shipmentWorkspaceHeader = "_fp-1";